import { connect } from 'react-redux'

import Actions from '../../Actions/Creators'
import UploadDocument from './Component/UploadDocument'
import Phi from './../../Phi/Phi'

const formatOrganization = (schoolContentID) => ({
  inOrganizationCustomJson: {schoolContentID: schoolContentID}
})

const mapStateToProps = (state, ownProps) =>{

  const userRole =  Phi.User.roles()

  return {
    reqDoc: state.organization.reqDoc,
    contentId: state.organization && state.organization.currentProgram && state.organization.currentProgram.organization_custom_json && state.organization.currentProgram.organization_custom_json.schoolContentID || null,
    updatedContentNodeId: state.organization.currentOrganizationContentId,
    inOrganizationId:  state.organization && state.organization.currentProgram && state.organization.currentProgram.in,
    orgData: state.organization && state.organization.currentProgram,
    org: state.organization,
    roleType: userRole && userRole.length && userRole[0].role_type_id
  }
}

const mapDispatchToProps = (dispatch) => ({
  onFileSubmit: (fileObj, contentId, category, fileGroup) => dispatch(Actions.onFileSubmit(fileObj, contentId, category, fileGroup)),
  removeDoc: (id, targetID, srcID, category, fileGroup) => dispatch(Actions.removeDoc(id, targetID, srcID, category, fileGroup)),
  toggleLoader: (flag, category) => dispatch(Actions.toggleLoader(flag, category)),
  fetchAllDocs: (contentId, fileGroup) => dispatch(Actions.fetchAllDocs(contentId, fileGroup)),
  updateOrganization: (orgId, schoolContentID) => dispatch(Actions.updateOrganization(orgId, formatOrganization(schoolContentID))),
  getProgramByOrganization: organization_id => dispatch(Actions.getProgramByOrganization(organization_id)),
});


export default connect(mapStateToProps, mapDispatchToProps)(UploadDocument)


// WEBPACK FOOTER //
// ./src/Containers/UploadDocumentContainer/index.js